import { Modal } from "@shopify/polaris";
import { OPEN_MODAL_BACK } from "../../../constants/modalTypes.js";
import { useCallback } from "react";
import { closeModal } from "../../../store/features/modal.js";
import { setStep, resetAction, resetAdvancedSettings, resetOptionsAndFrequency } from "../../../store/features/action.js";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux.js";
import { useSaveBarSafeNavigate } from "../../../hooks/useSaveBarSafeNavigate.js";

const BackModal = () => {
  const dispatch = useAppDispatch();
  const { isOpen, modalType, modalData } = useAppSelector((state) => state.modal);
  const navigate = useSaveBarSafeNavigate();

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const handleContinue = useCallback(() => {
    if (modalData.redirectToDashboard) {
      navigate('/dashboard');
    } else {
      switch (modalData.backStep + 1) {
        case 1:
          dispatch(resetAction());
          break;
        case 2:
          dispatch(resetOptionsAndFrequency());
          break;
        case 3:
          dispatch(resetAdvancedSettings());
          break;
        default:
          break;
      }
      dispatch(setStep(modalData.backStep));
    }
    handleClose();
  }, [dispatch, modalData, handleClose, navigate]);

  return (
    <Modal
      open={isOpen && modalType === OPEN_MODAL_BACK}
      onClose={handleClose}
      title="By leaving this view, you will lose your unsaved changes."
      primaryAction={{
        content: "Continue",
        onAction: handleContinue
      }}
      secondaryActions={[{
        content: "Cancel",
        onAction: handleClose
      }]}
    />
  );
};

export default BackModal;
